import React from 'react';

const SuccessMessage = () => (
  <div className="d-flex flex-column  tex-center align-itms-center press-success-box">
    <div className="press-success-image" />
    <h2 className="text-16 text-white press-success-text">
      Please check your email to verify your account. An Apptopian will review your request<br />after verificaton.
    </h2>
  </div>
);


export default SuccessMessage;
